export default __webpack_public_path__ + "static/favicon-lg-57bd11cdd73bf5031ae7431f10d33f2b.png";